// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3MhFG","header":"ReportDetails_header__OJKX9","title":"ReportDetails_title__3P10s","left":"ReportDetails_left__i5Opx"};